var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClansScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_43738)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_43738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_43738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4853 23.4853C27.1716 18.799 27.1716 11.201 22.4853 6.51472C17.799 1.82843 10.201 1.82843 5.51472 6.51472C0.828427 11.201 0.828427 18.799 5.51472 23.4853",
    stroke: "#FDBB53",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0711 22.0711C20.2901 22.8521 20.2901 24.1184 21.0711 24.8995C21.8522 25.6805 23.1185 25.6805 23.8996 24.8995L21.0711 22.0711ZM23.094 10.8329C24.7859 14.5266 24.1078 19.0344 21.0711 22.0711L23.8996 24.8995C28.1562 20.6429 29.0961 14.3312 26.7307 9.16713L23.094 10.8329Z",
    fill: "#81C259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10051 24.8995C4.88155 25.6805 6.14788 25.6805 6.92893 24.8995C7.70998 24.1184 7.70998 22.8521 6.92893 22.0711L4.10051 24.8995ZM6.92893 22.0711C3.89229 19.0344 3.21414 14.5266 4.90603 10.8329L1.26937 9.16713C-1.096 14.3312 -0.156134 20.6429 4.10051 24.8995L6.92893 22.0711Z",
    fill: "#F1564C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 1.5,
    width: 5,
    height: 20,
    rx: 2.5,
    fill: "#6E7379",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 15,
    r: 3,
    fill: "#6E7379"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_43738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClansScore);
export default __webpack_public_path__ + "static/media/clans_score.fdb63625b60688244202730b4e4cdedc.svg";
export { ForwardRef as ReactComponent };